import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnName,
  columnRole,
  columnWhat,
  columnWhen,
  columnResource,
  columnConsolidatedResource,
  columnSecondaryResource,
  columnUsername,
  hasColumn,
} from '@/constants/fields';
import AuditsSortedColumn from './AuditsSortedColumn';

const AuditsTableColumns = ({
  category,
  code,
  columns = [
    columnWhen,
    columnName,
    columnRole,
    columnWhat,
    columnResource,
  ],
}) => (
  <Table.Row>
    {hasColumn(columns, columnWhen) && <AuditsSortedColumn category={category} code={code} name={columnWhen} />}
    {hasColumn(columns, columnName) && (
      <AuditsSortedColumn category={category} code={code} name={columnName} orderByColumnFindName={columnUsername} />
    )}
    {hasColumn(columns, columnRole) && <AuditsSortedColumn category={category} code={code} name={columnRole} />}
    {hasColumn(columns, columnWhat) && <AuditsSortedColumn category={category} code={code} name={columnWhat} />}
    {hasColumn(columns, columnResource) && <AuditsSortedColumn category={category} code={code} name={columnResource} />}
    {hasColumn(columns, columnConsolidatedResource) && (
      <AuditsSortedColumn category={category} code={code} name={columnConsolidatedResource} />
    )}
    {hasColumn(columns, columnSecondaryResource) && (
      <AuditsSortedColumn category={category} code={code} name={columnSecondaryResource} />
    )}
  </Table.Row>
);

export default AuditsTableColumns;
